module.exports = __webpack_public_path__ + "assets/img/thumb-logitech-astrogaming.27c70f43.jpg";